import { render, staticRenderFns } from "./DesignSystem.vue?vue&type=template&id=820abb04&scoped=true&"
import script from "./DesignSystem.vue?vue&type=script&lang=js&"
export * from "./DesignSystem.vue?vue&type=script&lang=js&"
import style0 from "./DesignSystem.vue?vue&type=style&index=0&id=820abb04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820abb04",
  null
  
)

export default component.exports